const Routes = [
  {
    path: '/workspaces',
    name: 'workspaces',
    component: () => import('@/app/workspaces/TheWorkspace'),
    redirect: '/workspaces/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/workspaces/views/Index')
      },
      {
        path: 'new',
        name: 'newWorkspace',
        component: () => import('@/app/workspaces/views/NewWorkspace')
      },
      {
        path: ':workspaceId',
        name: 'updateWorkspace',
        component: () => import('@/app/workspaces/views/UpdateWorkspace'),
        props: true
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/workspaces/Routes.js